import React from 'react';
import { FsProps, FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';

const gqlGetRec = gql`
  query getWastedestinationtypes($where: String, $offset: Int, $limit: Int, $order: String) {
    getIdocwastedestinationtypes(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        description: name
      }
      recordCount
    }
  }
`;

// export function useGetCompanyTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCompanyTypesQuery, GetCompanyTypesQueryVariables>) {
//   return ApolloReactHooks.useLazyQuery<GetCompanyTypesQuery, GetCompanyTypesQueryVariables>(GetCompanyTypesDocument, baseOptions);
// }

function useGetRecLazyQuery() {
  return useLazyQuery(gqlGetRec, { fetchPolicy: 'no-cache' });
  //return [null, { loading: null, data: null }];
}

const FieldSelectWasteDestinationType = ({
  label = 'Παραλαβή Αποβλήτων',
  name = 'wasteDestinationTypeId',
  defaultValues = {},
  ...rest
}: FsProps) => {
  const sbLabel = (defaultValues as any)?.wastedestinationtype?.name ?? undefined;

  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      // @ts-ignore
      sbLabel={sbLabel}
      hook={useGetRecLazyQuery}
    />
  );
};

export default FieldSelectWasteDestinationType;

